<div class="modal-dialog" [attr.role]="'document'">
	<div class="modal-content">
		<p class="col-sm-2 col-sm-offset-10 generic-close-modal-btn">
			<button class="btn btn-default-reverse btn-block btn-sm"
				[attr.data-dismiss]="'modal'" type="button" (click)="createForm();">Chiudi</button>
		</p>
		<div>
			<div class="col-sm-12 coldx">
				<h3 class="title1level" style="margin-bottom: 20px;">Aggiungi spese legali</h3>
        <div spese-legali-form-add #formAddSpeseLegali [tipoPetitium]="tipoPetitium" (onReturn)="newSpesa($event)"></div>
      </div>
		</div>
	</div>
</div>
